export const MODULES = {
  navigation: 'nav',
  footer: 'footer',
} as const;

export type ModuleType = valueof<typeof MODULES>;
